import { render, staticRenderFns } from "./LookupResult.vue?vue&type=template&id=d9badd36"
import script from "./LookupResult.vue?vue&type=script&lang=js"
export * from "./LookupResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports